import { AccessIssueEntryMethodLabel, AccessIssuesEntryMethodDefinitions } from '@acp/shared';
import { useMemo } from 'react';
import { AccessIssuesWizardMachineContext } from './machine/context';

export function useEntryMethodDetails(entryMethod: AccessIssueEntryMethodLabel) {
    const definition = useMemo(
        () => AccessIssuesEntryMethodDefinitions[entryMethod],
        [entryMethod]
    );
    return definition;
}

export function useNextProblemSet() {
    const nextProblemSet = AccessIssuesWizardMachineContext.useSelector(
        (state) => (state.context.problemSet.queue.length > 0
            ? state.context.problemSet.queue[0]
            : null)
    );

    return nextProblemSet;
}

export function useIsInResolveMode() {
    const isInResolveMode = AccessIssuesWizardMachineContext.useSelector(
        (state) => state.matches('resolveIssue')
            || state.matches('resolveIssueCompleted')
            || state.matches('resolveIssuePending')
            || state.matches('resolveIssueNoSolutions')
    );

    return isInResolveMode;
}
